import { routePathCompany, routePathUser } from 'src/constants/router';
import type { Owner } from 'src/types/__generated__/graphql';

const getOwnerLink = (owner?: Owner) => {
    if (owner?.userId ?? owner?.user) {
        return `${routePathUser}/${owner.userId ?? owner.user?.id}`;
    }
    if (owner?.companyId ?? owner?.company) {
        return `${routePathCompany}/${owner.companyId ?? owner.company?.id}`;
    }

    return '/';
};

export default getOwnerLink;
